import React from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { makeSelectSiteCopy } from 'containers/Main/selectors';
import Content from './Content';

const Ribbon = () => {
  const data = useSelector(makeSelectSiteCopy());
  if (_isEmpty(data)) return null;
  const homeAnnouncement = data.filter(
    ({ slug }) => slug === 'home-announcement',
  )[0];
  const hasData = !_isEmpty(_get(homeAnnouncement, 'body.json'));
  if (!hasData) return null; // don't display if no content
  return <Content data={homeAnnouncement} />;
};

export default React.memo(Ribbon);
